import { Dialog, DialogType, IDialogContentProps } from "@fluentui/react";
import React from "react";
import { LanguageContext } from "../../utilities/LocalizationModule";
import { DuplicatePDFFileVersionSelector } from "../../src/taskpane/components/_v2/_shared/VersionSelector/DuplicatePDFFileVersionSelector";

export interface ICMDuplicateFileVersionSelectorModalProps {
  selectedItem: any;
  showDialog: boolean;
  closeDialog: () => void;
  closeOnSuccess: () => void;
  showSelectVersion: boolean;
  isDuplicate: boolean;
}

export const CMDuplicateFileVersionSelectorModal = ({ selectedItem, showDialog, closeDialog, closeOnSuccess, showSelectVersion, isDuplicate }: ICMDuplicateFileVersionSelectorModalProps) => {
  const languageStrings = React.useContext(LanguageContext);

  const dialogContentProps: IDialogContentProps = {
    type: DialogType.normal,
    title: languageStrings.SaveAsPdf,
    showCloseButton: true,
    closeButtonAriaLabel: 'Close'
  };

  return (
    <Dialog hidden={!showDialog} onDismiss={() => closeDialog()} dialogContentProps={dialogContentProps}>
      <DuplicatePDFFileVersionSelector showSelectVersion={showSelectVersion} isDuplicate={isDuplicate} selectedItem={selectedItem} onCancel={() => closeDialog()} onSuccess={() => closeOnSuccess()} />
    </Dialog>
  )
};